(function () {
  function initCollectionProductSlider(section) {
    if (!section) return;

    if (section.dataset.sliderInitialized === 'true') {
      return;
    }

    section.dataset.sliderInitialized = 'true';

    const track =
      section.querySelector('[data-slider-track]');

    const prevButton =
      section.querySelector('[data-slider-prev]');

    const nextButton =
      section.querySelector('[data-slider-next]');

    const progress =
      section.querySelector('[data-slider-progress]');

    if (!track) return;

    let resizeTimer = null;

    function getCardScrollAmount() {
      const firstCard =
        track.querySelector('.collection-product-card');

      if (!firstCard) {
        return track.clientWidth;
      }

      const trackStyles =
        window.getComputedStyle(track);

      const gap =
        parseFloat(trackStyles.gap) || 0;

      return (
        firstCard.getBoundingClientRect().width +
        gap
      );
    }

    function getMaxScroll() {
      return Math.max(
        track.scrollWidth - track.clientWidth,
        0
      );
    }

    function updateButtons() {
      const maxScroll = getMaxScroll();
      const currentScroll = track.scrollLeft;

      if (prevButton) {
        prevButton.disabled =
          currentScroll <= 3;
      }

      if (nextButton) {
        nextButton.disabled =
          currentScroll >= maxScroll - 3;
      }
    }

    function updateProgress() {
      if (!progress) return;

      const maxScroll = getMaxScroll();
      const currentScroll = track.scrollLeft;

      if (maxScroll <= 0) {
        progress.style.width = '100%';
        return;
      }

      const visibleRatio =
        track.clientWidth / track.scrollWidth;

      const baseWidth =
        Math.max(
          visibleRatio * 100,
          10
        );

      const travelRange =
        100 - baseWidth;

      const scrollPercentage =
        Math.min(
          Math.max(
            currentScroll / maxScroll,
            0
          ),
          1
        );

      const indicatorWidth =
        baseWidth +
        travelRange * scrollPercentage;

      progress.style.width =
        indicatorWidth + '%';
    }

    function updateSlider() {
      updateButtons();
      updateProgress();
    }

    function scrollPrevious() {
      track.scrollBy({
        left: -getCardScrollAmount(),
        behavior: 'smooth'
      });
    }

    function scrollNext() {
      track.scrollBy({
        left: getCardScrollAmount(),
        behavior: 'smooth'
      });
    }

    if (prevButton) {
      prevButton.addEventListener(
        'click',
        scrollPrevious
      );
    }

    if (nextButton) {
      nextButton.addEventListener(
        'click',
        scrollNext
      );
    }

    track.addEventListener(
      'scroll',
      updateSlider,
      {
        passive: true
      }
    );

    track.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          scrollNext();
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scrollPrevious();
        }

        if (event.key === 'Home') {
          event.preventDefault();

          track.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        }

        if (event.key === 'End') {
          event.preventDefault();

          track.scrollTo({
            left: getMaxScroll(),
            behavior: 'smooth'
          });
        }
      }
    );

    function handleResize() {
      if (resizeTimer) {
        window.clearTimeout(resizeTimer);
      }

      resizeTimer =
        window.setTimeout(
          function () {
            updateSlider();
          },
          80
        );
    }

    window.addEventListener(
      'resize',
      handleResize
    );

    if (
      typeof ResizeObserver !== 'undefined'
    ) {
      const resizeObserver =
        new ResizeObserver(
          function () {
            updateSlider();
          }
        );

      resizeObserver.observe(track);

      section._collectionSliderResizeObserver =
        resizeObserver;
    }

    if (
      typeof MutationObserver !== 'undefined'
    ) {
      const mutationObserver =
        new MutationObserver(
          function () {
            updateSlider();
          }
        );

      mutationObserver.observe(
        track,
        {
          childList: true,
          subtree: false
        }
      );

      section._collectionSliderMutationObserver =
        mutationObserver;
    }

    requestAnimationFrame(
      function () {
        updateSlider();
      }
    );

    window.setTimeout(
      function () {
        updateSlider();
      },
      200
    );
  }

  function destroyCollectionProductSlider(section) {
    if (!section) return;

    if (
      section._collectionSliderResizeObserver
    ) {
      section
        ._collectionSliderResizeObserver
        .disconnect();

      section._collectionSliderResizeObserver =
        null;
    }

    if (
      section._collectionSliderMutationObserver
    ) {
      section
        ._collectionSliderMutationObserver
        .disconnect();

      section._collectionSliderMutationObserver =
        null;
    }

    section.dataset.sliderInitialized = 'false';
  }

  function initAllCollectionProductSliders(root) {
    const scope = root || document;

    if (
      scope.matches &&
      scope.matches('[data-collection-slider]')
    ) {
      initCollectionProductSlider(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll(
          '[data-collection-slider]'
        )
        .forEach(
          initCollectionProductSlider
        );
    }
  }

  if (
    !window.__collectionProductSliderGlobalInit
  ) {
    window.__collectionProductSliderGlobalInit =
      true;

    if (
      document.readyState === 'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          initAllCollectionProductSliders(
            document
          );
        },
        {
          once: true
        }
      );
    } else {
      initAllCollectionProductSliders(
        document
      );
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        initAllCollectionProductSliders(
          event.target
        );
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      function (event) {
        const section =
          event.target.querySelector &&
          event.target.querySelector(
            '[data-collection-slider]'
          );

        if (section) {
          destroyCollectionProductSlider(
            section
          );
        }
      }
    );
  } else {
    initAllCollectionProductSliders(
      document
    );
  }
})();